import { CreateOrderRequest } from '@models/order';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import * as itemQuantityActions from './actions/itemQuantityActions';
import { updateOptionQuantity, resetPersonalOptions } from './actions/optionActions';
import { prepare } from './actions/prepareAction';

const initialState: Record<string, CreateOrderRequest> = {};

export const itemSlice = createSlice({
    name: 'item',
    initialState,
    reducers: {
        prepare,
        ...itemQuantityActions,
        updateOptionQuantity,
        resetPersonalOptions,
        cleanup: (state, action: PayloadAction<{ activityId: string }>) => {
            delete state[action.payload.activityId];
        },
    },
});

export const itemActions = itemSlice.actions;

export default itemSlice.reducer;
